import { useRef } from 'react';

export const useScrollIntoView = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // Inaktiverad — scroll vid sidbyte i grids är inte önskat beteende
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const scrollIntoView = () => {};

  return { scrollRef, scrollIntoView };
};
